import {useEffect, useState} from 'react';

const useTimeout = (ms: number = 0, initialState = false) => {
  const [ready, setReady] = useState(initialState);

  useEffect(() => {
    const timer = setTimeout(() => {
      setReady(!initialState);
    }, ms);

    return () => {
      clearTimeout(timer);
    };
  }, [ms]);

  return ready;
};

export default useTimeout;
